var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { join } from "framework/helpers";
import * as React from "react";
import { cls_label, cls_description_label, cls_error_label } from "./label.css";
export var Label = function (props) {
    var cls = join(cls_label, props.className);
    return React.createElement("label", __assign({}, props, { className: cls }));
};
export var DescriptionLabel = function (props) {
    var cls = join(cls_description_label, props.className);
    return React.createElement("label", __assign({}, props, { className: cls }));
};
export var ErrorLabel = function (props) {
    var cls = join(cls_error_label, props.className);
    return React.createElement("label", __assign({}, props, { className: cls }));
};
